import { tipoDocFilter } from 'pools/filterPool';
import './styles.scss';
import Button from "../../atoms/Button";
import { GlobalContext } from 'Context/GlobalContext/AppContext';
import { useContext, useState } from "react";


const TypeDocSelector = ({ filter, setFilter }) => {
    const { setQuantidadeModal, user } = useContext(GlobalContext);
    const [dummy, setDummy] = useState(null);

  function handleModalQuantificacao() {
    setQuantidadeModal((state) => !state);
  }

  return (
      <div className="filter__tipoDoc">
        {tipoDocFilter.map((newFilter) => (
            <label key={newFilter.id + newFilter.text} htmlFor={newFilter.id + newFilter.text} className="tipoDoc__item">
              <input
                    type="radio"
                    name="tipoDoc"
                    checked={newFilter.id === filter.tipoDoc}
                    id={newFilter.id + newFilter.text}
                    onChange={() => {
                        setFilter((prevState) => ({ ...prevState, tipoDoc: newFilter.id }))
                        setDummy(newFilter.id)
                        }
                    } 
              />
              <span className="checkmark"></span>
              {newFilter.text}
            </label>
        ))}
        {user.isAuthenticated && (
              <Button className={`button_modal`} onClick={handleModalQuantificacao} disabled={dummy == null }>
              {`Gerar relatório`}
            </Button>
        )}
      </div>
  );
};

export default TypeDocSelector;
